import React from 'react'
import { Typography, Form, Input, InputNumber,Space, Select, Button } from 'antd';
import BackOfficeService from '../../services/BackOfficeService';
import { useAuth } from '../../hooks/useAuth';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from '../../hooks/useLocalStorage';

const { Title, Text } = Typography;
export const FillBackOffice = ({isUpdate}) => {
  const [form] = Form.useForm();
  const { showNotification } = useAuth()
  const [user, setUser] = useLocalStorage("user", null);
  const navigate = useNavigate()

  const onLoad =async (rest) =>{
    const result = await BackOfficeService.createBackOfficer(rest);
    console.log(result)
    if (result.success) {
      showNotification('success', 'Created');
      form.resetFields();
    } else {
      showNotification('error', result.message);
    }
   
  }

  const onFinishCreate = (values) => {
    console.log('Success:', values);
    const {confirmPassword,...rest} = values;
    if(rest.password===confirmPassword){
      onLoad(rest)
    }else{
      showNotification('error', 'Confirm password is not match!')
    }
  };

  const onFinishUpdate = async(values) => {
    console.log('Success:', values);
    const {name,email,mobile} = values;
    console.log(name,email,mobile)
    // console.log({...user,email:email,name,mobile})
    const result = await BackOfficeService.updateProfile({
      newEmail : email,
      newMobile : mobile,
      newName: name
    });
    console.log(result)
    if (result.success) {
      showNotification('success', 'Updated');
      setUser({...user,email:email,name,mobile})
    } else {
      showNotification('error', result.message);
    }
  
  };

  return (
    <>
      <Space
        direction="horizontal"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem',
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          {isUpdate? "Update Profile" : "Create Back Officer"}
          
        </Title>
    
       
      </Space>
      <Form
        className="addAsset-form"
        onFinish={isUpdate?onFinishUpdate:onFinishCreate}
        form={form}
        labelCol={{
          span: 6,
        }}
        initialValues={{
          name: isUpdate ? user.name : "",
          email: isUpdate ? user.email : "",
          mobile: isUpdate ? user.mobile : "",
          role : isUpdate ? user.role : "",
          realm : isUpdate ? user.realm : ""
        }}
        // labelCol={{
        //   span: 8,
        // }}
        
        // onValuesChange={onRequiredTypeChange}
        // requiredMark={requiredMark}
      >
        <Form.Item
          label={'Name'}
          name={'name'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <Input />
        </Form.Item>
       
            <Form.Item
              label={'Realm'}
              name={'realm'}
             
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Select size="middle"  disabled={isUpdate}>
                {["FRONT_OFFICE","BACK_OFFICE"].map((item, index) => (
                  <Select.Option key={index} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

          
      
        <Form.Item
          label="Role"
          name={'role'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <Select size="middle" disabled={isUpdate}>
            {["ADMIN","MAKER","CHECKER"].map((item, index) => (
              <Select.Option key={index} value={item}>
                {item}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label={'Email'}
          name={'email'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <Input/>
        </Form.Item>
        {/* <Form.Item
          label="Security Code"
          name={'securityCode'}
          // rules={[
          //   {
          //     required: true,
          //     message: 'Please do not leave blank',
          //   },
          // ]}
        >
          <Input defaultValue={''} size="middle" disabled />
        </Form.Item> */}
        <Form.Item
          label={'Mobile'}
          name={'mobile'}
          rules={[
            {
              required: true,
              message: 'Please do not leave blank',
            },
          ]}
        >
          <Input/>
        </Form.Item>
        {
          !isUpdate&&(
            <>
              <Form.Item
                label={'Password'}
                name={'password'}
                rules={[
                  {
                    required: true,
                    message: 'Please do not leave blank',
                  },
                ]}
              >
                <Input.Password  />
              </Form.Item>
              <Form.Item
                label={'Confirm Password'}
                name={'confirmPassword'}
                rules={[
                  {
                    required: true,
                    message: 'Please do not leave blank',
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
            
            </>
          )
        }

        <Form.Item>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            key={'submit'}
            style={{ float: 'right' }}
          >
            {isUpdate?"Update":"Add"}
          </Button>
        </Form.Item>
      </Form>
      <Button type="default" size={'large'} onClick={() => navigate(-1)}>
      <ArrowLeftOutlined /> Back 
        </Button>
    </>
  )
}
